import React from 'react'
import { Box, HStack, Text, SimpleGrid, Image } from '@chakra-ui/react';
import GitHubCalendar from 'react-github-calendar';
import github from '../images/github.png';
const Skills = () => {
  return (
    <Box id="skills" textAlign="center" h={'auto'} >
      <HStack width={'100%'} color="white" alignItems={'center'} justifyContent={'center'} fontWeight={'500'} height={['50px', '60px', '70px']} bg={'gray.800'}>
        <Text fontSize={'xl'}>Tech Stacks</Text>
      </HStack>
      <Box width={'90%'} margin={'auto'} marginTop='5'>
        <SimpleGrid columns={[2, 3, 4]} padding='30px' height={'auto'}>
          <Box margin='auto'
            width={'170px'}
            height={'170px'}
            padding='20px'
            _hover={{ boxShadow: '0px 10px 12px 1px rgba(217,101,52,0.37)' }} >
            <Image margin='auto' width={'100px'} height={'100px'} alt='html5' src='https://cdn-icons-png.flaticon.com/128/174/174854.png' />
            <Text fontWeight={'600'} fontSize={['14px', '16px', '22px']} textAlign="center" color={'whiteAlpha.900'}>HTML</Text>
          </Box>
          <Box width={'170px'} margin='auto' height={'170px'} padding='20px'
            _hover={{ boxShadow: '0px 10px 12px 1px rgba(217,101,52,0.37)' }}
          >
            <Image margin='auto' width={'100px'} height={'100px'} alt='CSS3' src="https://upload.wikimedia.org/wikipedia/commons/3/3d/CSS.3.svg" />
            <Text fontWeight={'600'} fontSize={['14px', '16px', '22px']} textAlign="center" color={'whiteAlpha.900'}>CSS</Text>
          </Box>
          <Box
            _hover={{ boxShadow: '0px 10px 12px 1px rgba(217,101,52,0.37)' }}
            width={'170px'} height={'170px'} margin='auto' padding='20px'>
            <Image margin='auto' width={'100px'} height={'100px'} alt='Javascript' src="https://img.icons8.com/color/2x/javascript.png" />
            <Text fontWeight={'600'} fontSize={['14px', '16px', '22px']} textAlign="center" color={'whiteAlpha.900'}>Javascript</Text>
          </Box>
          <Box _hover={{ boxShadow: '0px 10px 12px 1px rgba(217,101,52,0.37)' }}
            width={'170px'} height={'170px'} margin='auto' padding='20px'>
            <Image margin='auto' width={'100px'} height={'85px'} alt='React' src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/768px-React-icon.svg.png?20220125121207" />
            <Text fontWeight={'600'} fontSize={['14px', '16px', '22px']} textAlign="center" color={'whiteAlpha.900'}>React</Text>
          </Box>
          <Box width={'170px'} height={'170px'} margin='auto' padding='20px' marginTop='10px'
            _hover={{ boxShadow: '0px 10px 12px 1px rgba(217,101,52,0.37)' }}>
            <Image width={'100px'} margin='auto' height={'100px'} alt='NodeJs' src="https://cdn.worldvectorlogo.com/logos/nodejs-2.svg" />
            <Text fontWeight={'600'} fontSize={['14px', '16px', '22px']} textAlign="center" color={'whiteAlpha.900'}>NodeJs</Text>
          </Box>
          <Box _hover={{ boxShadow: '0px 10px 12px 1px rgba(217,101,52,0.37)' }} marginTop='10px'
            width={'170px'} height={'170px'} margin='auto' padding='20px'>
            <Image width={'100px'} height={'100px'} alt='express' margin='auto' src="https://assets.website-files.com/61ca3f775a79ec5f87fcf937/6202fcdee5ee8636a145a41b_1234.png" />
            <Text fontWeight={'600'} fontSize={['14px', '16px', '22px']} textAlign="center" color={'whiteAlpha.900'}>Express</Text>
          </Box>
          <Box width={'170px'} padding='20px' height={'170px'} margin='auto' marginTop='10px'
            _hover={{ boxShadow: '0px 10px 12px 1px rgba(217,101,52,0.37)' }}
          >
            <Image width={'100px'} height={'100px'} margin='auto' alt='MongoDb' src="https://p.kindpng.com/picc/s/385-3850420_mongodb-svg-png-download-svg-png-mongodb-icon.png" />
            <Text fontWeight={'600'} fontSize={['14px', '16px', '22px']} textAlign="center" color={'whiteAlpha.900'}>MongoDb</Text>
          </Box>
          <Box width={'170px'} padding='20px' height={'170px'} margin='auto' marginTop='10px'
            _hover={{ boxShadow: '0px 10px 12px 1px rgba(217,101,52,0.37)' }} >
            <Image width={'100px'} height={'100px'} alt='Redux' margin='auto' src="https://img.icons8.com/color/2x/redux.png" />
            <Text fontWeight={'600'} fontSize={['14px', '16px', '22px']} textAlign="center" color={'whiteAlpha.900'}>Redux</Text>
          </Box>
        </SimpleGrid>
      </Box>
      <Box width={'90%'} margin={'auto'} marginTop={5}>
        <Text fontSize={'2xl'} fontWeight='500' color='white'><u>Tools</u></Text>
        <SimpleGrid columns={[2, 3, 5]} padding='30px' height={'auto'}>
          <Box margin='auto'
            width={'170px'}
            height={'170px'}
            padding='20px'
            _hover={{ boxShadow: '0px 10px 12px 1px rgba(217,101,52,0.37)' }} >
            <Image margin='auto' width={'100px'} height={'100px'} alt='github' src={github} />
            <Text fontWeight={'600'} fontSize={['14px', '16px', '22px']} textAlign="center" color={'whiteAlpha.900'}>Github</Text>
          </Box>
          <Box margin='auto'
            width={'170px'}
            height={'170px'}
            padding='20px'
            _hover={{ boxShadow: '0px 10px 12px 1px rgba(217,101,52,0.37)' }} >
            <Image margin='auto' width={'100px'} height={'100px'} alt='vs Code' src={'https://cdn.thenewstack.io/media/2021/10/4f0ac3e0-visual_studio_code.png'} />
            <Text fontWeight={'600'} fontSize={['14px', '16px', '22px']} textAlign="center" color={'whiteAlpha.900'}>Vs Code</Text>
          </Box>
          <Box _hover={{ boxShadow: '0px 10px 12px 1px rgba(217,101,52,0.37)' }}
            width={'170px'} height={'170px'} padding='20px' margin='auto'>
            <Image width={'100px'} height={'100px'} margin='auto' alt='Chakra UI' src="https://www.coffeeclass.io/logos/chakra-ui.png" />
            <Text fontWeight={'600'} fontSize={['14px', '16px', '22px']} textAlign="center" color={'whiteAlpha.900'}>Chakra-Ui</Text>
          </Box>
          <Box margin='auto'
            width={'170px'}
            height={'170px'}
            padding='20px'
            _hover={{ boxShadow: '0px 10px 12px 1px rgba(217,101,52,0.37)' }} >
            <Image margin='auto' width={'100px'} height={'100px'} alt='html5' src={'https://ayushmanbh.netlify.app/static/media/netlify.c779369f.svg'} />
            <Text fontWeight={'600'} fontSize={['14px', '16px', '22px']} textAlign="center" color={'whiteAlpha.900'}>Netlify</Text>
          </Box>
          <Box margin='auto'
            width={'170px'}
            height={'170px'}
            padding='20px'
            _hover={{ boxShadow: '0px 10px 12px 1px rgba(217,101,52,0.37)' }} >
            <Image margin='auto' width={'100px'} height={'100px'} alt='html5' src={'https://avatars.githubusercontent.com/u/18133?s=200&v=4'} />
            <Text fontWeight={'600'} fontSize={['14px', '16px', '22px']} textAlign="center" color={'whiteAlpha.900'}>Git</Text>
          </Box>
        </SimpleGrid>
      </Box>
      <Box display={'flex'} flexDirection='column' alignItems={'center'} justifyContent='center' color={'whiteAlpha.900'} marginTop='15px'>
        <Text fontSize={'2xl'} fontWeight='500' color='white'><u>Github Stats</u></Text>
        <GitHubCalendar username='gprasadbhat948231' />
      </Box>
      <SimpleGrid columns={[1, 1, 2]} margin='auto' width='70%' marginBottom='20px' marginTop='30px' color={'whiteAlpha.900'}>
        <Box>
          <img src="https://github-readme-stats.vercel.app/api/top-langs?username=gprasadbhat948231&show_icons=true&locale=en&layout=compact"
            alt="gprasadbhat948231" style={{ height: '200px' }} />
        </Box>
        <Box>
          <img src="https://github-readme-stats.vercel.app/api?username=gprasadbhat948231&show_icons=true&locale=en"
            alt="gprasadbhat948231" style={{ height: '200px' }} />
        </Box>
      </SimpleGrid>
    </Box>
  )
}

export default Skills